import { SVGProps } from 'react';

const SvgFlask = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M176 196.8c0 20.7-5.8 41-16.6 58.7L119.7 320h208.6l-39.7-64.5c-10.9-17.7-16.6-38-16.6-58.7V48h-96v148.8zM320 48v148.8c0 11.8 3.3 23.5 9.5 33.5l108.2 175.9a69.54 69.54 0 0 1 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4H69.4C31.1 512 0 480.9 0 442.6c0-12.8 3.6-25.4 10.3-36.4l108.2-175.8c6.2-10.1 9.5-21.7 9.5-33.5V48h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h208c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8z" />
  </svg>
);
export default SvgFlask;
